import FormRenderer from './formRenderer';
import React from 'react';

function ArticleForm({ formId, contentArticleFormId }) {
  return (
    <div className="container">
      <div className="row">
        <aside className="sidebar">&nbsp;</aside>

        <article className="content no-margin-top margin-bottom-xs">
          <div className="row">
            <div className="col-1-of-2 main-content content-lg">
              {FormRenderer.formWithId(formId, contentArticleFormId)}
            </div>
          </div>
        </article>

        <aside className="spacebar">&nbsp;</aside>
      </div>
    </div>
  );
}

ArticleForm.propTypes = {
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number
};

export default ArticleForm;



// WEBPACK FOOTER //
// ./components/forms/articleForm.js